// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#modal-content {
  padding: 15px;
}

.submit-button {
  background-color: #e9af51;
  border: none;
  color: white;
  padding: 0px 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  margin-right: 15px;
  margin: 20px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}

::ng-deep .edit {
  margin-top: 50px;
  width: 700px;
  margin-left: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/dialog-edit-request/dialog-edit-request.component.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;AADJ;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAGA;EACE,kCAAA;AAAF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;AACF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n#modal-content {\r\n    padding: 15px;\r\n}\r\n\r\n.submit-button {\r\n  background-color: $secondary-color;\r\n  border: none;\r\n  color: white;\r\n  padding: 0px 5px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 4px 2px;\r\n  cursor: pointer;\r\n  margin-right: 15px;\r\n  margin: 20px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n::ng-deep .edit{\r\n  margin-top: 50px;\r\n  width: 700px;\r\n  margin-left: 40px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
